import React, { useEffect, useState } from "react";
import Dashboard from "./dashboard";
import axios from "../api/baseurl";
import "./Spinner.css";
import "./Loader.css";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import jsPDF from "jspdf";
import "jspdf-autotable"; 
import tmplLogo from "../images/tmplLogo.png";
import * as XLSX from 'xlsx';
import { saveAs } from "file-saver";
import { Pagination } from "react-bootstrap";

function AppointmentReportsByTransactionDateForAdmin() {
  const [appointmentDetails, setAppointmentDetails] = useState([]);
  const [allAppDetails, setAllAppDetails] = useState([]);
  const [allAppNotTaken, setAllAppNotTaken] = useState([]);
  const [loader, setLoader] = useState(false); 
  const [fromDate, setFromDate] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0); 
  const [toDate, setToDate] = useState(""); 
  const [status, setStatus] = useState([]); 
  const [appointmentType, setAppointmentType] = useState("all"); 
  const [appNotTakenData, setAppNotTakenData] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("all");
  const [companyDetails, setCompanyDetails] = useState([]);
  const dateType="transactionDate";

  const userRole=JSON.parse(localStorage.getItem("data")).role;

  const navigate = useNavigate();

  const token = JSON.parse(localStorage.getItem("data")).token;


  // Function to fetch data based on selected fromDate, toDate, and status
const getData = async (pageNumber = 0) => {
    
    // Prepare request options with Authorization header
    const options = {
      params: { page: pageNumber },
        headers: { Authorization: `Bearer ${token}` },
    };
  
     const reportUrl = `/api/appointmentReport/getPagedAppointmentsByDateRangeAndFiltersByRole`;

const requestBody = {
  companyId: selectedCompany === "all" ? null : selectedCompany.id,
  fromDate: fromDate,
  toDate: toDate,
  appointmentStatus: status.length > 0 ? status : null,  // Ensure it's an array or null
  dateType: dateType,
  appointmentType: appointmentType === "all" ? null : appointmentType,
};

try {
  setLoader(true);
  const response = await axios.post(reportUrl, requestBody, options);
         setAppointmentDetails(response.data.empAppointments);
         setCurrentPage(response.data.currentPage);
         setTotalPages(response.data.totalPages);
         setAppNotTakenData([]);
       } catch (error) {
         handleError(error);
       } finally {
         setLoader(false); // Hide loader after fetching data
       }
     };
   
     const getAppNotTakenEmpData = async (pageNumber = 0) => {
       const token = JSON.parse(localStorage.getItem("data")).token;
       
       // Prepare request options with Authorization header
       const options = {
        params: { page: pageNumber },
          headers: { Authorization: `Bearer ${token}` },
      };
     
       try {
         setLoader(true); 
         let response;

         const requestBody = {
          companyId: selectedCompany === "all" ? null : selectedCompany.id,
        };
     
        //  if (selectedOrgcode) {
        //    response = await axios.get(`/api/employeedetails/getAppointmentsNotTakenEmployees/companycode=${selectedOrgcode}`, options
        //    );
        //  } 
        //  else {
           response = await axios.post('/api/employeedetails/getPagedAppointmentsNotTakenEmployees',requestBody, options);
        //  }
         setAppNotTakenData(response.data.content);
         setCurrentPage(response.data.number);
         setTotalPages(response.data.totalPages);
         setAppointmentDetails([]);
         setFromDate("");
         setToDate("");
         setStatus([]);
         setAppointmentType("all");
       } catch (error) {
         handleError(error);
       } finally {
         setLoader(false); // Hide loader after fetching data
       }
     };
     
    useEffect(() => {
  const fetchData = async () => {
    try {
      const token = JSON.parse(localStorage.getItem("data"))?.token;
      const orgcode = JSON.parse(localStorage.getItem("data"))?.orgcode;

      if (!token) return;

      if (userRole !== 'ROLE_EMPLOYER') {
        const companyRes = await axios.get("/api/companydetails/getCompanies", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setCompanyDetails(companyRes.data);
      } else {
        const res = await axios.get(`/api/companydetails/companycode=${orgcode}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setSelectedCompany(res.data);
      }
    } catch (error) {
      handleError(error);
    }
  };

  fetchData();
}, []);

     
  // Error handling function
  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An error occurred.");
      }
    } else {
      toast.error("An error occurred.");
    }
  }

  // Function to handle "Generate" button click
  const handleGenerateReport = () => {
    // Only fetch data if both fromDate and toDate are selected
    if (fromDate && toDate) {
      getData(0);
    } else {
      toast.error("Please select both From Date and To Date.");
    }
  };

  const renderPageNumbers = () => {
      const pageNumbers = [];
      const maxPageNumbersToShow = 5;
      let startPage = Math.max(0, currentPage - 2);
      let endPage = Math.min(totalPages - 1, currentPage + 2);
  
      if (currentPage <= 2) {
        endPage = Math.min(totalPages - 1, maxPageNumbersToShow - 1);
      }
  
      if (currentPage >= totalPages - 3) {
        startPage = Math.max(0, totalPages - maxPageNumbersToShow);
      }
  
      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(
          <Pagination.Item key={i} active={i === currentPage} onClick={() => handlePageChange(i)}>
            {i + 1}
          </Pagination.Item>
        );
      }
      return pageNumbers;
    };
  
    const handlePageChange = (newPage) => {
      setCurrentPage(newPage);
      if(appointmentDetails.length>0){
        getData(newPage);
      }else{
        getAppNotTakenEmpData(newPage);
      }

    };

  const handleAppNotTakenReport = () => {
      getAppNotTakenEmpData();
  };

  const [showDropdown, setShowDropdown] = useState(false);

  const [showNotTakenDropdown, setShowNotTakenDropdown] = useState(false);

  const [isOpen, setIsOpen] = useState(false);

  const statusOptions = [
    "APPOINTMENT CONFIRMATION PENDING WITH LAB",
    "APPOINTMENT CONFIRMED",
    "APPOINTMENT RESCHEDULED",
    "APPOINTMENT COMPLETED",
    "APPOINTMENT CANCELLED"
  ];

  // Handle checkbox changes
  const handleCheckboxChange = (e) => {
    const value = e.target.value;
    if (value === "All") {
      // If "All" is selected/deselected, update the status accordingly
      if (status.includes("All")) {
        setStatus([]); // Deselect "All" and uncheck everything
      } else {
        setStatus(statusOptions.slice(1)); // Select all other statuses
      }
    } else {
      if (status.includes(value)) {
        setStatus(status.filter((item) => item !== value)); // Remove status from array
      } else {
        setStatus([...status, value]); // Add selected status to array
      }
    }
  };


  const handleDownloadReport = async (format) => {
    if (!fromDate && !toDate) {
      toast.error("Please select both From Date and To Date.");
      return
    }

    const reportUrl = `/api/appointmentReport/getAllAppointmentsByDateRangeAndFiltersByRole`;
  
    const requestBody = {
      companyId: selectedCompany === "all" ? null : selectedCompany.id,
      fromDate: fromDate,
      toDate: toDate,
      appointmentStatus: status.length > 0 ? status : null, // Ensure it's an array or null
      dateType: dateType,
      appointmentType: appointmentType === "all" ? null : appointmentType,
    };

    const options = {
        headers: { Authorization: `Bearer ${token}` },
    };
  
    try {
      setLoader(true);
      
      // 🔹 Call API first
      const response = await axios.post(reportUrl, requestBody, options);

      const appDetails=response.data.empAppointments;
      
      setAllAppDetails(response.data.empAppointments); // Set response data
      
      if (response.data.empAppointments.length === 0) {
        setLoader(false);
        toast.error("No data available for the selected filters");
        return;
      }
  
  if (appNotTakenData.length > 0 || appDetails.length > 0) {
    if (format === "pdf") {
      const doc = new jsPDF("l", "mm", "a4");

      const logoWidth = 40;
      const logoHeight = 10;
      const titleFontSize = 16;
      const titleMargin = 10;

      // Add Logo
      doc.addImage(tmplLogo, "PNG", 10, 10, logoWidth, logoHeight);

      // Title
      doc.setFontSize(titleFontSize);
      const pageWidth = doc.internal.pageSize.width;
      const titleText =
        appNotTakenData.length > 0
          ? "Appointment Not Taken Employees Report"
          : "Employees Appointment Report";
      const titleWidth =
        (doc.getStringUnitWidth(titleText) * titleFontSize) /
        doc.internal.scaleFactor;
      const titleX =
        (pageWidth - logoWidth - titleMargin - titleWidth) / 2 +
        logoWidth +
        titleMargin;

        doc.text(titleText, titleX, 20);
        doc.setFontSize(12);
        
        let startY = 30;
        
        // Combine header info into one line
        let metaLine1 = '';
        let metaLine2 = '';
        
        // First line: Company Code, From-To, Appointment Type
        if (selectedCompany) metaLine1 += `Company Code: ${selectedCompany.companycode}    `;
        if (appDetails.length > 0) metaLine1 += `From: ${fromDate}  To: ${toDate}    `;
        if (appointmentType) metaLine1 += `Appointment Type: ${appointmentType}`;
        
        // Second line: Appointment Status
        if (Array.isArray(status) && status.length > 0) {
          metaLine2 += `Appointment Status: ${status.join(", ")}`;
        }
        
        // Draw first line
        if (metaLine1) {
          doc.text(metaLine1, 14, startY);
          startY += 10;
        }
        
        // Draw second line
        if (metaLine2) {
          doc.text(metaLine2, 14, startY);
          startY += 10;
        }
        
        
        // Table Columns
        const tableColumn = appNotTakenData.length > 0
          ? [
              "Sl No.",
              "Name",
              "Employee ID",
              "Email",
              "Phone Number",
              "Company Code",
            ]
          : [
              "Sl No.",
              "Name",
              "Transaction Date",
              "Appointment Date",
              "Package",
              "Employee ID",
              "Email",
              "Phone Number",
              "Company",
              "Lab",
              "Appointment Type",
              "Appointment Status",
            ];
        
        // Table Rows
        const tableRows = [];
        
        if (appNotTakenData.length > 0) {
          appNotTakenData.forEach((appointment, index) => {
            tableRows.push([
              index + 1,
              `${appointment.name} ${appointment.lastname}`,
              appointment.empid,
              appointment.email,
              appointment.phoneno,
              appointment.company?.companycode,
            ]);
          });
        } else {
          appDetails.forEach((appointment, index) => {
            tableRows.push([
              index + 1,
              appointment.fullName,
              appointment.transactionDate,
              appointment.appointmentDate,
              appointment.packageName,
              appointment.employeeId !== null ? appointment.employeeId : 'NA',
              appointment.email,
              appointment.phoneNumber,
              appointment.companyName,
              `${appointment.labName} (${appointment.labCode})`,
              appointment.appointmentType,
              appointment.appointmentStatus,
            ]);
          });
        }
        
        // Single autoTable call — allow 10 per page
        doc.autoTable({
          head: [tableColumn],
          body: tableRows,
          startY: startY + 10,
          margin: { top: 10, bottom: 30 },
          showHead: 'everyPage',
          theme: 'striped',
          styles: {
            fontSize: 8,
            cellPadding: 2,
            overflow: 'linebreak',
          },
          bodyStyles: {
            minCellHeight: 8,
          },
          didDrawPage: (data) => {
            const pageHeight = doc.internal.pageSize.height;
            doc.setFontSize(10);
            doc.setTextColor(128, 128, 128);
            doc.text(
              "This is a system-generated report and does not need a signature.",
              14,
              pageHeight - 20
            );
          },
          // force 10 rows per page
          pageBreak: 'auto',
          rowPageBreak: 'avoid',
          pageBreakBefore: (data) => {
            return false; // disable forced breaks — let it auto-paginate based on height
          },
        });
        
        // Page Numbers
        const pageCount = doc.internal.getNumberOfPages();
        for (let i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          doc.text(
            `Page ${i} of ${pageCount}`,
            doc.internal.pageSize.width - 20,
            doc.internal.pageSize.height - 10,
            { align: 'right' }
          );
        }
        

      // Save PDF
      const fileName = `Appointment_Report_${fromDate || ""}_to_${
        toDate || ""
      }.pdf`;
      doc.save(fileName);
    } else if (format === "excel") {
      let wsData = [];

      // Add Headers
      wsData.push(
        appNotTakenData.length > 0
          ? [
              "Sl No.",
              "Name",
              "Employee ID",
              "Email",
              "Phone Number",
              "Company Code",
            ]
          : [
              "Sl No.",
              "Name",
              "Transaction Date",
              "Appointment Date",
              "Package",
              "Employee ID",
              "Email",
              "Phone Number",
              "Company",
              "Lab",
              "Appointment Type",
              "Appointment Status",
            ]
      );

      // Add Data Rows
      if (appNotTakenData.length > 0) {
        appNotTakenData.forEach((appointment, index) => {
          wsData.push([
            index + 1,
            `${appointment.name} ${appointment.lastname}`,
            appointment.empid,
            appointment.email,
            appointment.phoneno,
            appointment.company?.companycode,
          ]);
        });
      } else {
        appDetails.forEach((appointment, index) => {
          wsData.push([
            index + 1,
            appointment.fullName,
            appointment.transactionDate,
            appointment.appointmentDate,
            appointment.packageName,
            appointment.employeeId!==null?appointment.employeeId:'NA',
            appointment.email,
            appointment.phoneNumber,
            appointment.companyName,
            `${appointment.labName} (${appointment.labCode})`,
            appointment.appointmentType,
            appointment.appointmentStatus,
          ]);
        });
      }

      // Create Workbook
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.aoa_to_sheet(wsData);
      XLSX.utils.book_append_sheet(wb, ws, "Appointments");

      // Save Excel File
      const fileName = `Appointment_Report_${fromDate || ""}_to_${
        toDate || ""
      }.xlsx`;
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: "application/octet-stream" });
      saveAs(data, fileName);
    }
  } else {
    toast.error("No data available to generate report.");
  }
} catch (error) {
  console.error("Error fetching report data:", error);
  toast.error("Failed to fetch report data");
} finally {
  setLoader(false); // Ensure loader is turned off in all cases
}
};

const handleDownloadAppNotTakenEmpReport = async (format) => {
 
  const reportUrl = `/api/employeedetails/getAllAppointmentsNotTakenEmployees`;

  const requestBody = {
    companyId: selectedCompany === "all" ? null : selectedCompany.id,
  };

  const options = {
      headers: { Authorization: `Bearer ${token}` },
  };

  try {
    setLoader(true);
    
    // 🔹 Call API first
    const response = await axios.post(reportUrl, requestBody, options);

    const appNotTakenDetails=response.data;
    
    setAllAppNotTaken(response.data); // Set response data
    
    if (appNotTakenDetails.length === 0) {
      setLoader(false);
      toast.error("No data available for the selected filters");
      return;
    }

if (appNotTakenDetails.length > 0) {
  if (format === "pdf") {
    const doc = new jsPDF("l", "mm", "a4");

    const logoWidth = 40;
    const logoHeight = 10;
    const titleFontSize = 16;
    const titleMargin = 10;

    // Add Logo
    doc.addImage(tmplLogo, "PNG", 10, 10, logoWidth, logoHeight);

    // Title
    doc.setFontSize(titleFontSize);
    const pageWidth = doc.internal.pageSize.width;
    const titleText =
       "Appointment Not Taken Employees Report";
    const titleWidth =
      (doc.getStringUnitWidth(titleText) * titleFontSize) /
      doc.internal.scaleFactor;
    const titleX =
      (pageWidth - logoWidth - titleMargin - titleWidth) / 2 +
      logoWidth +
      titleMargin;

      doc.text(titleText, titleX, 20);
      doc.setFontSize(12);
      
      let startY = 30;
      
      // Combine header info into one line
      let metaLine1 = '';
    
      // First line: Company Code, From-To, Appointment Type
      if (selectedCompany) metaLine1 += `Company Code: ${selectedCompany.companycode}    `;
     
      // Draw first line
      if (metaLine1) {
        doc.text(metaLine1, 14, startY);
        startY += 10;
      }
    
      
      // Table Columns
      const tableColumn = [
            "Sl No.",
            "Name",
            "Employee ID",
            "Email",
            "Phone Number",
            "Company Code",
          ]
       
      // Table Rows
      const tableRows = [];
      
      if (appNotTakenDetails.length > 0) {
        appNotTakenDetails.forEach((appointment, index) => {
          tableRows.push([
            index + 1,
            `${appointment.name} ${appointment.lastname}`,
            appointment.empid,
            appointment.email,
            appointment.phoneno,
            appointment.company?.companycode,
          ]);
        });
      }
      
      // Single autoTable call — allow 10 per page
      doc.autoTable({
        head: [tableColumn],
        body: tableRows,
        startY: startY + 10,
        margin: { top: 10, bottom: 30 },
        showHead: 'everyPage',
        theme: 'striped',
        styles: {
          fontSize: 10,
          cellPadding: 3,
          overflow: 'linebreak',
        },
        bodyStyles: {
          minCellHeight: 8,
        },
        didDrawPage: (data) => {
          const pageHeight = doc.internal.pageSize.height;
          doc.setFontSize(10);
          doc.setTextColor(128, 128, 128);
          doc.text(
            "This is a system-generated report and does not need a signature.",
            14,
            pageHeight - 20
          );
        },
        // force 10 rows per page
        pageBreak: 'auto',
        rowPageBreak: 'avoid',
        pageBreakBefore: (data) => {
          return false; // disable forced breaks — let it auto-paginate based on height
        },
      });
      
      // Page Numbers
      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.text(
          `Page ${i} of ${pageCount}`,
          doc.internal.pageSize.width - 20,
          doc.internal.pageSize.height - 10,
          { align: 'right' }
        );
      }
      

    // Save PDF
    const fileName = `Appointment_Report_${fromDate || ""}_to_${
      toDate || ""
    }.pdf`;
    doc.save(fileName);
  } else if (format === "excel") {
    let wsData = [];

    // Add Headers
    wsData.push(
      [
            "Sl No.",
            "Name",
            "Employee ID",
            "Email",
            "Phone Number",
            "Company Code",
          ]
      
    );

    // Add Data Rows
    if (appNotTakenDetails.length > 0) {
      appNotTakenDetails.forEach((appointment, index) => {
        wsData.push([
          index + 1,
          `${appointment.name} ${appointment.lastname}`,
          appointment.empid,
          appointment.email,
          appointment.phoneno,
          appointment.company?.companycode,
        ]);
      });
    }
    // Create Workbook
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, "Appointments");

    // Save Excel File
    const fileName = `Appointment_Report_${fromDate || ""}_to_${
      toDate || ""
    }.xlsx`;
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, fileName);
  }
} else {
  toast.error("No data available to generate report.");
}
} catch (error) {
console.error("Error fetching report data:", error);
toast.error("Failed to fetch report data");
} finally {
setLoader(false); // Ensure loader is turned off in all cases
}
};

  return (
    <div>
      <Dashboard />
      {loader && <div className="loading"></div>}
      <div className="col-12 mx-xl-auto ps-xl-10 mt-10">
        <div className="card card-raised">
          <div className="card-body">
            <div className="card-title form-group d-flex align-items-center justify-content-between">
              Appointments Reports By Transaction Date
            </div>
            <br />
            <div className="row">
              {userRole!=='ROLE_EMPLOYER' &&(
            <div className="col-md-2 mb-3">
    <label htmlFor="companyId">
      Select Company
    </label>
    <select
      className="form-select"
       onChange={(e) => {
        const selected = companyDetails.find(comp => comp.id === parseInt(e.target.value));
        setSelectedCompany(selected || "all");
      }}
    >
      <option value="all">All</option>
      {companyDetails.map((comp) => (
        <option key={comp.id} value={comp.id}>
          {comp.companyname}
        </option>
      ))}
    </select>
  </div>
              )}


              <div className="col-md-2">
                <label>From Date:</label>
                <input
                  type="date"
                  className="form-control"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </div>
              <div className="col-md-2">
                <label>To Date:</label>
                <input
                  type="date"
                  className="form-control"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </div>
              <div className="col-md-4">
      <label>Appointment Status:</label>
      <div>
        <div className="custom-dropdown" onClick={() => setIsOpen(!isOpen)}>
          <div className="selected-options">
            {status.length > 0 ? status.join(", ") : "Select Appointment Status"}
          </div>
          <div className="dropdown-arrow">▼</div>
        </div>

        {isOpen && (
          <div className="dropdown-options">
            {statusOptions.map((statusOption) => (
              <div key={statusOption} className="dropdown-item">
                <input
                  type="checkbox"
                  className="form-check-input"
                  value={statusOption}
                  checked={status.includes(statusOption)}
                  onChange={handleCheckboxChange}
                />
                <label className="form-check-label">{statusOption}</label>
              </div>
            ))}
          </div>
        )}
      </div>

      <style jsx>{`
        .custom-dropdown {
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 8px;
          border: 1px solid #ccc;
          border-radius: 4px;
          width: 340px; /* Set width to a smaller value */
          font-size: 14px; /* Adjust font size for a more compact view */
        }
        .dropdown-arrow {
          font-size: 12px;
        }
        .dropdown-options {
          position: absolute;
          border: 1px solid #ccc;
          border-radius: 4px;
          margin-top: 4px;
          background-color: white;
          width: 340px; /* Same width as the dropdown */
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
          z-index: 100;
          font-size: 12px; /* Adjust font size */
        }
        .dropdown-item {
          padding: 6px;
          display: flex;
          align-items: center;
        }
        .dropdown-item:hover {
          background-color: #f0f0f0;
        }
        .dropdown-item input {
          margin-right: 8px;
        }
        .selected-options {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      `}</style>
    </div>
<div className="col-md-2">
                <label>Appointment Type :</label>
                <select
                  className="form-select"
                  value={appointmentType}
                  onChange={(e) => setAppointmentType(e.target.value)}
                >
                  <option value="all">ALL</option>
                  <option value="ahc">
                    AHC
                  </option>
                  <option value="peme">PEME</option>
                </select>
              </div>

            </div>
  
            <br />
            <div className="d-flex justify-content-between align-items-center mb-3">
      {/* Left Button */}
      <div className="d-flex align-items-center">
      <button className="btn btn-secondary me-3" onClick={handleAppNotTakenReport}>
        Appointment Not Taken
      </button>

      <div className="dropdown">
          {/* Button to toggle dropdown */}
          <button
            className="btn btn-primary dropdown-toggle"
            onClick={() => setShowNotTakenDropdown(!showNotTakenDropdown)}
          >
            Download Report
          </button>
          {showNotTakenDropdown && (
            <ul className="dropdown-menu show" style={{ display: "block", position: "absolute" }}>
              <li>
                <a className="dropdown-item" onClick={() => handleDownloadAppNotTakenEmpReport('pdf')}>
                  PDF
                </a>
              </li>
              <li>
                <a className="dropdown-item" onClick={() => handleDownloadAppNotTakenEmpReport('excel')} >
                  Excel
                </a>
              </li>
            </ul>
          )}
        </div>
        </div>

      {/* Right Section: Generate Report + Download Dropdown */}
      <div className="d-flex align-items-center">
        <button className="btn btn-primary me-3" onClick={handleGenerateReport}>
          Generate Report
        </button>

        <div className="dropdown">
          {/* Button to toggle dropdown */}
          <button
            className="btn btn-primary dropdown-toggle"
            onClick={() => setShowDropdown(!showDropdown)}
          >
            Download Report
          </button>

          {/* Show dropdown if state is true */}
          {showDropdown && (
            <ul className="dropdown-menu show" style={{ display: "block", position: "absolute" }}>
              <li>
                <a className="dropdown-item" onClick={() => handleDownloadReport('pdf')}>
                  PDF
                </a>
              </li>
              <li>
                <a className="dropdown-item" onClick={() => handleDownloadReport('excel')} >
                  Excel
                </a>
              </li>
            </ul>
          )}
        </div>
      </div>
    </div>
  
            <br />
            {(appointmentDetails.length===0 && appNotTakenData.length===0) &&(
              <td colSpan="7" className="text-center">
                      No Data Available
                    </td>
            )}
            {appNotTakenData.length === 0 && appointmentDetails.length>0 &&(
                    <>
                    <h5>Appointment Taken Employees :</h5>
                    <br/>
                    <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr className="table-header">
                  <th>Sl.No.</th>
                  <th>Name</th>
                  <th>Transaction Date</th>
                  <th>Appointment Date</th>
                  <th>Package</th>
                  <th>Employee Id</th>
                  <th>Email</th>
                  <th>Phone Number</th>
                  <th>Company</th>
                  <th>Lab</th>     
                  <th>Appointment Type</th>          
                  <th>Appointment Status</th>
                </tr>
              </thead>
              <tbody>
                {/* Render Regular Appointment Details */}
                {appointmentDetails.length === 0 && appNotTakenData.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="text-center">
                      No Data Available
                    </td>
                  </tr>
                ) : (
                  <>
                    {appointmentDetails.map((appointment, index) => (
                      <tr key={appointment.id}>
                        <td>{index + 1}</td>
                        <td>
                          {appointment.fullName}
                        </td>
                        <td>{appointment.transactionDate}</td>
                        <td>{appointment.appointmentDate}</td>
                        <td>{appointment.packageName}</td>
                        <td>{appointment.employeeId!==null?appointment.employeeId:'NA'}</td>
                        <td>{appointment.email}</td>
                        <td>{appointment.phoneNumber}</td>
                        <td>{appointment.companyName}</td>
                        <td>{appointment.labName}</td>
                        <td>{appointment.appointmentType}</td>
                        <td>{appointment.appointmentStatus}</td>
                      </tr>
                    ))}
                  </>
                )}
              </tbody>
            </table>
            <div className="d-flex justify-content-center">
                          <Pagination>
                            <Pagination.First onClick={() => handlePageChange(0)} disabled={currentPage === 0} />
                            <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0} />
                            {renderPageNumbers()}
                            <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages - 1} />
                            <Pagination.Last onClick={() => handlePageChange(totalPages - 1)} disabled={currentPage === totalPages - 1} />
                          </Pagination>
                        </div>
            </div>
            </>
            )}
{appNotTakenData.length > 0 && (
    <>
    <h5>Appointment Not Taken Employees :</h5>
    <br/>
<table className="table table-bordered">
              <thead>
                <tr className="table-header">
                <th>Sl.No.</th>
                  <th>Name</th>
                  <th>Employee Id</th>
                  <th>Email</th>
                  <th>Phone Number</th>
                  <th>Company Code</th>
                </tr>
              </thead>
              <tbody>
                {/* Render Regular Appointment Details */}
                {appNotTakenData.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="text-center">
                      No Data Available
                    </td>
                  </tr>
                ) : (
       
                    appNotTakenData.map((employee, index) => (
                      <tr key={employee.id}>
                       <td>{index + 1}</td>
                        <td>
                          {employee.name} {employee.lastname}
                        </td>
                        <td>{employee.empid}</td>
                        <td>{employee.email}</td>
                        <td>{employee.phoneno}</td>
                        <td>{employee.company?.companycode}</td>
                      </tr>
                    ))
                )}
              </tbody>
            </table>
            <div className="d-flex justify-content-center">
                          <Pagination>
                            <Pagination.First onClick={() => handlePageChange(0)} disabled={currentPage === 0} />
                            <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0} />
                            {renderPageNumbers()}
                            <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages - 1} />
                            <Pagination.Last onClick={() => handlePageChange(totalPages - 1)} disabled={currentPage === totalPages - 1} />
                          </Pagination>
                        </div>
            </>
            )}
          </div>
        </div>
      </div>
      {loader && <div className="loading"></div>}
    </div>
  );
  
}

export default AppointmentReportsByTransactionDateForAdmin;
